import { IonRow,IonCol, useIonViewWillEnter} from '@ionic/react';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import CampaignCard from '../../components/CampaignCard';
import { Fundraiser } from '../../models/data';
import { translation } from '../../models/translation';
import { fetchAllFundraisers } from '../../services/fundraise_service';

const FundraiseList: React.FC = () => {

  const lan=translation().lan.replace("/","");
  const history = useHistory();

  const [fundraiseList, setFundraiseList] = useState<Fundraiser[]>([])

  const pathName = useLocation().pathname;

  const isAccountPage = () => {
    if (pathName.indexOf('account') < 0) return false;
    return true
  }

  useIonViewWillEnter(() => {
    fetchAllFundraisers().then(m => {
      setFundraiseList(m.message)
    }
    )
  })

  const navigate = (e: string) => {

    if(isAccountPage()){
      history.push(`/${lan}/account/fundraisers/${e}`);
    }else{
      history.push(`/${lan}/fundraisers/${e}`)
    }
  }


  return (
    <IonRow className='ion-justify-content-center'>
      <IonCol size='10'>
        <IonRow className='fundraiserPage'>
          {fundraiseList && fundraiseList.map((m, key) =>
            <CampaignCard key={key} title={m.title} imageUrl={m.acf.image} description={m.acf.reason} id={m.id} navigate={navigate} ></CampaignCard>
          )}
        </IonRow>
      </IonCol>
    </IonRow>
  );
};

export default FundraiseList;
